import { createLoadingReducer } from './utils';

export default createLoadingReducer('RCO_SETTINGS');
